export type CatalogFeaturedLotsInfo = {
    catalogId: number;
    catalogTitle: string;
    endDate: string;
    /**
     * The lot number of the featured lots
     */
    featuredLots: string[];
    houseName: string;
};

export type FeaturedLotsSlice = {
    byId: {
        [catalogId: number]: CatalogFeaturedLotsInfo;
    };
    error: {
        [catalogId: number]: string;
    };
    isLoading: boolean;
    success: boolean;
    suggestionsById: {
        [catalogId: number]: SuggestedFeaturedLot[];
    };
};

export const defaultFeaturedLotsSlice: FeaturedLotsSlice = {
    byId: {},
    error: {},
    isLoading: false,
    success: false,
    suggestionsById: {},
};

export const emptyCatalogFeaturedLotsInfo: CatalogFeaturedLotsInfo = {
    catalogId: 0,
    catalogTitle: '',
    endDate: '',
    featuredLots: [],
    houseName: '',
};

export type SaveFeaturedLotsByCatalogIdParams = {
    catalogId: number;
    lotNumbers: string[];
};

export enum FeaturedLotsRequestError {
    AlreadyEnded = 'Auction has already ended.',
    CatalogDoesntExist = 'Catalog with provided ID does not exist.',
    /**
     * this one requires additional information when creating the error
     */
    DuplicateLots = 'Duplicate lot numbers exist:',
    /**
     * this one requires additional information when creating the error
     */
    InvalidLotCount = 'Lot count must be:',
    LotNumbersEmpty = 'Lot numbers cannot be empty.',
    /**
     * this one requires additional information when creating the error
     */
    LotsAlreadyPromoted = 'Lots already featured in other promotion. Please choose a different lot:',
    /**
     * this one requires additional information when creating the error
     */
    LotsDontExist = "Lot numbers don't exist in the catalog. Please check the lot number and try again:",
    Other = 'An unexpected error occurred. Please try again.',
}

export type SuggestedFeaturedLot = {
    imageUrl: string;
    lotId: number;
    lotNumber: string;
    lotTitle: string;
};
